import { OnInit } from '@angular/core';
import { WorkspaceService } from '../services/workspace.service';
var KeyIndicatorComponent = /** @class */ (function () {
    function KeyIndicatorComponent(workspaceService) {
        this.workspaceService = workspaceService;
        this.isBusy = false;
        this.keyIndicatorArrays = [];
    }
    Object.defineProperty(KeyIndicatorComponent.prototype, "setComponentId", {
        set: function (id) {
            this.componentId = id;
            this.refreshKPI();
        },
        enumerable: true,
        configurable: true
    });
    KeyIndicatorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isBusy = true;
        setTimeout(function () {
            if (!_this.componentId) {
                _this.isBusy = false;
            }
        }, 15000);
    };
    KeyIndicatorComponent.prototype.refreshKPI = function () {
        var _this = this;
        if (this.componentId) {
            this.workspaceService.getKpiCard(this.componentId).subscribe(function (result) {
                _this.kpiCardObject = JSON.parse(result);
                if (result) {
                    for (var key in _this.kpiCardObject.KeyIndicatorObjects) {
                        _this.keyIndicatorArrays.push(_this.kpiCardObject.KeyIndicatorObjects[key]);
                    }
                }
                _this.isBusy = false;
            }, function (error) {
                _this.isBusy = false;
            });
        }
    };
    return KeyIndicatorComponent;
}());
export { KeyIndicatorComponent };
var KeyIndicatorObjects = /** @class */ (function () {
    function KeyIndicatorObjects() {
    }
    return KeyIndicatorObjects;
}());
export { KeyIndicatorObjects };
